<app-dialog-wrapper [content]="data.content">

	<div class="dialog-wrapper">
		<div class="loading-wrapper" [ngClass]="{'loading': loading}">
			<i class="fal fa-spinner-third fa-spin"></i>
		</div>
		<div class="dialog-inner">
			<div class="dialog-form-wrapper">

				<app-input-wrapper blend class="flex-none" label="Time">
					<div class="date-input-wrapper">
						<div class="date-input-value">{{dateInputObject | date: 'HH:mm'}}</div>
						<input (ngModelChange)="updateDate($event)" [(ngModel)]="dateInputString" class="date-input" id="DateInput" type="datetime-local"/>
					</div>
				</app-input-wrapper>

				<ng-container [ngComponentOutlet]="dialogEditComps[data.type]" [ngComponentOutletInputs]="{rec: data.data}"></ng-container>

			</div>
			<div class="dialog-footer">
				<div class="dialog-btn" (click)="onCancel()">Cancel</div>
				<div class="dialog-btn" (click)="onConfirm()">Confirm</div>
			</div>
		</div>
	</div>
</app-dialog-wrapper>
